import { useEffect, useState } from "react";

const STORAGE_KEY = "request-edit:chat-width";

function readStoredWidth(fallback: number): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) return fallback;

    const parsed = Number(raw);

    return Number.isFinite(parsed) && parsed > 0 && parsed < 100
      ? parsed
      : fallback;
  } catch {
    return fallback;
  }
}

function persistWidth(width: number) {
  try {
    localStorage.setItem(STORAGE_KEY, String(width));
  } catch {}
}

export function usePersistedChatWidth(defaultWidth: number) {
  const [chatWidth, setChatWidth] = useState(() =>
    readStoredWidth(defaultWidth),
  );

  useEffect(() => {
    persistWidth(chatWidth);
  }, [chatWidth]);

  return [chatWidth, setChatWidth] as const;
}
